import React from "react";
import { useTranslation } from "react-i18next";

const DomainConnectForm = ({
  idPrefix,
  value,
  error,
  isSubmitting,
  onChange,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form
      id={`${idPrefix}-form`}
      onSubmit={handleSubmit}
      className="rounded-xl border border-gray-200 bg-white p-4"
    >
      <label
        className="block mb-2 text-sm font-medium text-gray-900"
        htmlFor={`${idPrefix}_input`}
      >
        {t("settings:custom_domain_input_label")}
      </label>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="text"
          id={`${idPrefix}_input`}
          value={value}
          onChange={onChange}
          placeholder={t("settings:custom_domain_placeholder")}
          className={`bg-gray-50 border text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        />
        <button
          type="submit"
          id={`${idPrefix}-submit`}
          disabled={isSubmitting}
          className="shrink-0 inline-flex items-center justify-center rounded-lg bg-cfPrimaryButton px-4 py-2.5 text-sm font-medium text-white hover:bg-cfPrimaryDark focus:outline-none focus:ring-2 focus:ring-cfPrimaryButton/50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting
            ? t("settings:custom_domain_submitting")
            : t("settings:custom_domain_submit")}
        </button>
      </div>
      {error ? (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      ) : (
        <p className="text-xs text-gray-500 mt-1">
          {t("settings:custom_domain_subdomain_hint")}
        </p>
      )}
      {onCancel && (
        <button
          type="button"
          id={`${idPrefix}-cancel`}
          onClick={onCancel}
          disabled={isSubmitting}
          className="mt-2 text-xs font-medium text-gray-500 underline underline-offset-2 hover:text-gray-700 disabled:opacity-50"
        >
          {t("settings:cancel")}
        </button>
      )}
    </form>
  );
};

export default DomainConnectForm;
